import gql from "graphql-tag";
import { getVarID } from "./messages";

export const GET_ROOM_SIGNALS_MULTIPLE = (rooms) => {
    const roomsVariables = rooms
        ?.map((room) => {
            const varID = getVarID(room);
            return {
                [`r${varID}ProjectRef`]: room.projectRef,
                [`r${varID}RoomNumber`]: room.roomNumber,
                [`r${varID}Password`]: room.password || room.roomCode || room.code,
                [`r${varID}LastSignalID`]: room.lastSignalID ?? null,
            };
        })
        .reduce((a, b) => ({ ...a, ...b }), {});

    const strGql = `
            query getRoomSignals(
                ${rooms
                    ?.map((room) => {
                        const varID = getVarID(room);
                        return `$r${varID}ProjectRef: ID!
                $r${varID}RoomNumber: Int!
                $r${varID}Password: String!
                $r${varID}LastSignalID: Int64
                `;
                    })
                    .join("\n")}
            ) {
                ${rooms
                    ?.map((room) => {
                        const varID = getVarID(room);
                        return `roomSignals${varID}: getRoomSignals(
                    hotelRef: $r${varID}ProjectRef
                    roomNumber: $r${varID}RoomNumber
                    password: $r${varID}Password
                    lastSignalID: $r${varID}LastSignalID
                ) {
                    results {
                        id
                        createdAt
                        expiresAt
                        payload
                        signalType
                    }
                }`;
                    })
                    .join("\n")}
            }
        `;

    return {
        id: "GET_ROOM_SIGNALS_MULTIPLE_" + rooms?.map((room) => room.roomNumber).join("-"),
        query:
            rooms?.length > 0
                ? gql(strGql)
                : gql`
                      {
                          getLanguage(ref: "en") {
                              name
                          }
                      }
                  `,
        defaultVars: {
            ...roomsVariables,
        },
    };
};
